import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/jobtoken/ton-onboarding.png")